import { useState, useEffect } from "react";

const AlertMessage = ({
  message,
  type = "success",
  duration = 3000,
  setVisible,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer); // cleanup on unmount
  }, [duration]);

  return (
    <div
      className={`alert alert-${type} alert-dismissible fade show`}
      role="alert"
    >
      {message}
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={() => setVisible(false)}
      ></button>
    </div>
  );
};

export default AlertMessage;
